const pageNameKey = "thingsHubSearch";

export const thingsHubSearchEn = {
  [pageNameKey]: {
    thingsSearchPlaceholder:
      "Ask anything...how do I perform a fill study on a new mold?",
    activeSubmitButtonText: "Create support ticket",
    inactiveSubmitButtonText: "Enter title to create support ticket",
    deactivateDragModeText: "Deactivate drag mode to enable send button",
  },
};

export const thingsHubSearchPtBr = {
  [pageNameKey]: {
    thingsSearchPlaceholder:
      "Pergunte qualquer coisa... como faço um estudo de preenchimento em um novo molde?",
    activeSubmitButtonText: "Criar ticket de suporte",
    inactiveSubmitButtonText:
      "Insira um título para criar um ticket de suporte",
    deactivateDragModeText:
      "Desative o modo de arrastar para habilitar o botão de envio",
  },
};

export const thingsHubSearchDe = {
  [pageNameKey]: {
    thingsSearchPlaceholder:
      "Fragen Sie alles... wie führe ich eine Füllstudie für ein neues Werkzeug durch?",
    activeSubmitButtonText: "Support-Ticket erstellen",
    inactiveSubmitButtonText:
      "Titel eingeben, um ein Support-Ticket zu erstellen",
    deactivateDragModeText:
      "Drag-Modus deaktivieren, um den Senden-Button zu aktivieren",
  },
};

export const thingsHubSearchZhHans = {
  [pageNameKey]: {
    thingsSearchPlaceholder: "询问任何问题……如何对新模具进行填充分析？",
    activeSubmitButtonText: "创建支持工单",
    inactiveSubmitButtonText: "输入标题以创建支持工单",
    deactivateDragModeText: "关闭拖拽模式以启用发送按钮",
  },
};

export const thingsHubSearchIt = {
  [pageNameKey]: {
    thingsSearchPlaceholder:
      "Chiedi qualsiasi cosa... come eseguire uno studio di riempimento su un nuovo stampo?",
    activeSubmitButtonText: "Crea ticket di supporto",
    inactiveSubmitButtonText:
      "Inserisci un titolo per creare un ticket di supporto",
    deactivateDragModeText:
      "Disattiva la modalità trascinamento per abilitare il pulsante di invio",
  },
};

export const thingsHubSearchEs = {
  [pageNameKey]: {
    thingsSearchPlaceholder:
      "Pregunta lo que sea... ¿cómo realizo un estudio de llenado en un molde nuevo?",
    activeSubmitButtonText: "Crear ticket de soporte",
    inactiveSubmitButtonText:
      "Introduce un título para crear un ticket de soporte",
    deactivateDragModeText:
      "Desactiva el modo de arrastre para habilitar el botón de envío",
  },
};

export const thingsHubSearchNl = {
  [pageNameKey]: {
    activeSubmitButtonText: "Supportticket aanmaken",
    deactivateDragModeText:
      "Schakel de drag-modus uit om de verzendknop te activeren",
    inactiveSubmitButtonText:
      "Voer een titel in om een supportticket aan te maken",
    thingsSearchPlaceholder:
      "Vraag alles... hoe voer ik een vulstudie uit voor een nieuwe matrijs?",
  },
};

export const thingsHubSearchTr = {
  [pageNameKey]: {
    activeSubmitButtonText: "Destek bileti oluştur",
    deactivateDragModeText:
      "Gönder düğmesini etkinleştirmek için sürükleme modunu devre dışı bırakın",
    inactiveSubmitButtonText: "Destek bileti oluşturmak için başlığı girin",
    thingsSearchPlaceholder:
      "Herhangi bir şey sorun... Yeni bir kalıp üzerinde dolgu çalışmasını nasıl yapabilirim?",
  },
};
